export default __webpack_public_path__ + "52f45f284a3ded6947715cb2bcf32e7a.png";